import {
  areaAddressApi,
  areaAddressClient,
  formatAddressAuthClient
} from '../base/experianAddressClient';
import Globals from '../../constants/appConstants';

const checkoutAddressClient = body => {

  const requestBody = {
    query: body.query,
    country: 'USA',
    take: 10,
    'auth-token': Globals.token.experian
  };
  return areaAddressClient.get(
    areaAddressApi.getAreaAddresses(),
    requestBody,
    mapResponse,
    mapError
  );
};

const checkoutNormalizeAddressClient = url => {

  const requestBody = {
    
    'auth-token': Globals.token.experian
  };
  return formatAddressAuthClient.get(url, requestBody, mapResponse, mapError);
};

//map response to object needed by React view
const mapResponse = response => {
  return response;
};

//map error to object needed by React view
const mapError = error => {
  return error;
};

export { checkoutAddressClient, checkoutNormalizeAddressClient };
